/**
 * Лёгкое превью картинки раздела: `<имя>.webp` → `<имя>_preview.webp` (длинная сторона ≤512px, его делает бэк при
 * загрузке медиа карточек). Для мест, где картинка маленькая: значок стиля мультистиля (30px) качал оригинал —
 * замер 30.09 на трендах: 250–280 КБ за значок, у одной карточки четыре стиля — больше мегабайта; превью —
 * 18–24 КБ. У всех 18 стилей мультистиля на трендах превью есть; нет — компонент PreviewImg откатывается на оригинал.
 */
// Без lookbehind: Safari до 16.4 его не знает, и модуль упал бы при разборе — вместе с ним весь сайт.
const SECTION_IMAGE = /\/sections\/[^/?#]+\.webp(?=$|[?#])/
const ALREADY_PREVIEW = /_preview\.webp(?=$|[?#])/

export function sectionPreviewUrl(url: string): string {
	return SECTION_IMAGE.test(url) && !ALREADY_PREVIEW.test(url) ? url.replace(/\.webp(?=$|[?#])/, '_preview.webp') : url
}
